import React, { useState, ReactNode } from 'react';
import { useTranslations } from 'next-intl';

interface Props {
    children: ReactNode;
    maxLines?: number;
    className?: string;
}

export function ExpandableText({ children, maxLines = 3, className = '' }: Props) {
    const [isExpanded, setIsExpanded] = useState(false);
    const t = useTranslations();

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const getLineClampClass = (lines: number) => {
        const clampMap: { [key: number]: string } = {
            1: 'line-clamp-1',
            2: 'line-clamp-2',
            3: 'line-clamp-3',
            4: 'line-clamp-4',
            5: 'line-clamp-5',
            6: 'line-clamp-6',
        };
        return clampMap[lines] || 'line-clamp-3';
    };

    return (
        <div className={className}>
            <div
                className={`${
                    !isExpanded ? getLineClampClass(maxLines) : ''
                } overflow-hidden transition-all duration-300 ease-in-out`}>
                {children}
            </div>
            <button
                type="button"
                onClick={toggleExpanded}
                className="mt-2 text-sm font-medium underline focus:outline-none focus:ring-2 focus:ring-offset-2">
                {isExpanded ? t('general.readLess') : t('general.readMore')}
            </button>
        </div>
    );
}
